import { Moment } from 'moment';

export const getValidMoment = (date: Moment) => {
  return date.isValid() ? date : undefined;
};
